import { initSpamOption, SpamScenarioId } from 'owa-spam-row-option';
import { runAfterBootstrap } from 'owa-delayed-initialization';
export { default as BlockedSendersAndDomainsOptionV2 } from './BlockedSendersAndDomainsOptionV2';

runAfterBootstrap(() => {
    initSpamOption(SpamScenarioId.BlockedSendersAndDomains);
});
